export type InternalNetworkTunnelRoutingStatus = {
  connected: boolean;
  reconnecting?: boolean;
  routeTorchThroughSession?: boolean;
};

export type InternalNetworkTunnelListenerStatus =
  InternalNetworkTunnelRoutingStatus & {
    httpProxyPort?: number;
    socksPort?: number;
  };

export const isInternalNetworkTunnelRoutingTorch = (
  status: InternalNetworkTunnelRoutingStatus,
): boolean =>
  (status.connected || status.reconnecting === true) &&
  status.routeTorchThroughSession !== false;

export const isInternalNetworkTunnelReplacingUpstream = ({
  corporateUpstreamEnabled,
  status,
}: {
  corporateUpstreamEnabled: boolean;
  status: InternalNetworkTunnelRoutingStatus;
}): boolean =>
  corporateUpstreamEnabled && isInternalNetworkTunnelRoutingTorch(status);

export const toInternalNetworkTunnelTerminalRouting = (
  status: InternalNetworkTunnelListenerStatus,
): { httpProxyPort: number; socksPort: number } | null => {
  if (
    !isInternalNetworkTunnelRoutingTorch(status) ||
    status.httpProxyPort === undefined ||
    status.socksPort === undefined
  ) {
    return null;
  }

  return {
    httpProxyPort: status.httpProxyPort,
    socksPort: status.socksPort,
  };
};
